import React, { useEffect, useState, memo } from "react"
import styles from "./Board.module.css"
import { useAppContext } from "../../stores/appStore"

const Board = memo(function Board() {
    const { showBoard, remainingSeconds, jackpotHit, quotes } = useAppContext()
    const [currentPage, setCurrentPage] = useState(0)
    const [hiddenText, setHiddenText] = useState(false)
    useEffect(() => {
        let intervalId

        if (showBoard && !jackpotHit) {
            // Rotate through 3 pages every 5 seconds
            intervalId = setInterval(() => {
                setCurrentPage((prev) => (prev + 1) % 3)
                setHiddenText(false)
                setTimeout(() => {
                    setHiddenText(true)
                }, 4900)
            }, 5000)
        } else {
            // Reset to the first page when `showBoard` becomes true
            setCurrentPage(0)
            setTimeout(() => {
                setHiddenText(true)
            }, 4900)
            setHiddenText(false)
        }

        return () => {
            setHiddenText(false)
            setTimeout(() => {
                setHiddenText(true)
            }, 4900)
            // Cleanup the interval on unmount or when showBoard changes
            clearInterval(intervalId)
        }
    }, [showBoard, jackpotHit])

    useEffect(() => {
        // Reset to the first page when `remainingSeconds` reaches 0
        if (remainingSeconds === 0) {
            setTimeout(() => {
                setCurrentPage(0)
            }, 2000)
        }
    }, [remainingSeconds])

    return (
        <div
            className={`${styles.board} ${
                showBoard && !jackpotHit && styles.show
            }`}
        >
            <div className={styles.offset}></div>
            <div className={`${styles.inner} ${hiddenText && styles.hidden}`}>
                {currentPage === 0 && (
                    <>
                        <div className={styles.title}>
                            Gânduri înainte de zbor
                        </div>
                        <div className={styles.text}>{quotes[0]}</div>
                    </>
                )}
                {currentPage === 1 && (
                    <>
                        <div className={styles.title}>
                            Gânduri înainte de zbor
                        </div>
                        <div className={`${styles.text} ${styles.second}`}>
                            {quotes[1]}
                        </div>
                    </>
                )}
                {currentPage === 2 && (
                    <>
                        <div className={styles.title}>
                            Gânduri înainte de zbor
                        </div>
                        <div className={`${styles.text} ${styles.third}`}>
                            {quotes[2]}
                        </div>
                    </>
                )}
            </div>
        </div>
    )
})

export default Board
